// src/compoents/layout/Footer.jsx
import { siteMeta } from "../data/siteContent";

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container-shell footer-shell">
        <div className="footer-top-card">
          <div className="footer-brand">
            <img src={siteMeta.logo} alt="Dryvziro" className="footer-logo" />
            <div>
              <h2>Dryvziro</h2>
              <p>
                Transforming transport data into measurable fleet savings.
              </p>
            </div>
          </div>

          <a
            href={siteMeta.ctaHref}
            target="_blank"
            rel="noreferrer"
            className="btn btn--primary"
          >
            {siteMeta.ctaLabel}
          </a>
        </div>

        <div className="footer-grid">
          <div>
            <h4>CONTACT</h4>
            <ul>
              <li><a href={`mailto:${siteMeta.contactEmail}`}>{siteMeta.contactEmail}</a></li>
              <li><a href={`tel:${siteMeta.contactPhone.replace(/\s/g, '')}`}>{siteMeta.contactPhone} [click to call]</a></li>
              <li>WhatsApp: <a href={siteMeta.whatsappHref} target="_blank" rel="noreferrer">{siteMeta.contactPhone} [click to WhatsApp]</a></li>
              <li>{siteMeta.location}</li>
            </ul>
          </div>

          <div>
            <h4>NAVIGATE</h4>
            <ul>
              <li>
                <a href="#how">How It Works</a>
              </li>
              <li>
                <a href="#impact">Results</a>
              </li>
              <li>
                <a href="#partners">Who It Serves</a>
              </li>
              <li>
                <a href="#technology">Technology</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>TECHNOLOGY</h4>
            <ul>
              <li>
                <a href="#technology">Transparency</a>
              </li>
              <li>
                <a href="#partners">Partners</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{siteMeta.copyright}</span>
          <div>
            <a href="#">Privacy Policy</a>
            <a href="#">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
